<template>
  <b-taginput
    :value="formattedValue"
    autocomplete
    :icon="icon"
    :placeholder="placeholder"
    :field="field"
    :maxtags="maxtags"
    :maxlength="maxlength"
    :data="filteredTags"
    :allow-new="allowNew"
    :open-on-focus="openOnFocus"
    :has-counter="hasCounter"
    @input="$emit('input', $event)"
    @typing="onTyping"
  />
</template>

<script>

export default {
  props: {
    data: {
      required: true,
      type: Array
    },
    value: {
      required: true
    },
    placeholder: {
      default: undefined,
      type: String
    },
    field: {
      default: undefined,
      type: String
    },
    icon: {
      default: "label",
      type: String
    },
    maxtags: {
      type: Number,
      default: undefined
    },
    maxlength: {
      type: Number,
      default: undefined
    },
    allowNew: {
      type: Boolean,
      default: false
    },
    openOnFocus: {
      type: Boolean,
      default: false
    },
    hasCounter: {
      default: true,
      type: Boolean
    }
  },
  data () {
    return {
      query: ""
    };
  },
  computed: {
    formattedValue () {
      return _.isArray(this.value) ? this.value : [];
    },
    filteredTags() {
      return this.data.filter((option) => {
        let field = null;

        if (_.isString(option)) {
          field = option;
        }

        if (_.isPlainObject(option) && _.isString(option[this.field])) {
          field = option[this.field];
        }

        if (field == null) {
          return false;
        }

        return field
          .toString()
          .toLowerCase()
          .indexOf(this.query.toLowerCase()) >= 0;
      });
    }
  },
  methods: {
    onTyping (query) {
      this.query = query;
      this.$emit("typing", query);
    }
  }
};
</script>
